export const inview = (node, params = {}) => {
  let observer;
  const { root = null, threshold = 0.5, rootMargin = '0px' } = params;

  const observe = () => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          node.dispatchEvent(new CustomEvent('inview', { detail: entry }));
        });
      },
      { root, threshold, rootMargin },
    );

    observer.observe(node);
  };

  const unobserve = () => {
    if (observer) {
      observer.disconnect();
    }
  };

  observe();

  return {
    update(newParams) {
      unobserve();
      Object.assign(params, newParams);
      observe();
    },
    destroy() {
      unobserve();
    },
  };
};